import * as React from "react";

function GovtSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32.562}
      height={32.562}
      {...props}
    >
      <path
        d="M7.986 22.622h-.008a.954.954 0 00-.952.954v8.986h1.912v-8.986a.954.954 0 00-.952-.954zM16.253 21.331h-.008a.954.954 0 00-.952.954v10.277h1.912V22.285a.954.954 0 00-.952-.954zM24.584 22.622h-.008a.954.954 0 00-.952.954v8.986h1.912v-8.986a.954.954 0 00-.952-.954z"
        fill="#ff7b16"
      />
      <ellipse
        cx={0.956}
        cy={0.954}
        rx={0.956}
        ry={0.954}
        transform="translate(15.325 11.355)"
        fill="#ff7b16"
      />
      <path
        d="M21.748 16.8h10.814v-2.28a.955.955 0 00-.618-.894L17.233 8.107V5.724h5.229a.953.953 0 00.952-.954V1.59a.953.953 0 00-.952-.954h-5.284a.951.951 0 00-1.849.318v7.153L.639 13.621l-.021.008a.954.954 0 00-.618.894V16.8h10.814a1.064 1.064 0 010 2.127H1.337v12.681a.953.953 0 00.952.954h2.833v-8.986a2.862 2.862 0 012.856-2.862h.008a2.862 2.862 0 012.856 2.862v8.986h2.547V22.285a2.862 2.862 0 012.856-2.862h.008a2.862 2.862 0 012.856 2.862v10.277h2.611v-8.986a2.862 2.862 0 012.856-2.862h.008a2.862 2.862 0 012.856 2.862v8.986h2.833a.953.953 0 00.952-.954V18.93h-9.477a1.064 1.064 0 010-2.127zm-5.467-1.632a2.862 2.862 0 112.86-2.862 2.864 2.864 0 01-2.86 2.865z"
        fill="#ff7b16"
      />
    </svg>
  );
}

export default GovtSvg;
